import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import {
  DisclosurePanel as HeadlessDisclosurePanel,
  TransitionRoot,
} from "@headlessui/vue";
import { useAttrs, computed } from "vue";

interface PanelProps extends ExtractProps<typeof HeadlessDisclosurePanel> {
  as?: string | object;
}
// eslint-disable-next-line

const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Panel',
  props: {
    as: { default: "div" }
  },
  setup(__props: any) {

const { as } = __props as { as: string | object }



const attrs = useAttrs();
const computedClass = computed(() =>
  twMerge([
    "mt-3 text-slate-700 leading-relaxed dark:text-slate-400",
    typeof attrs.class === "string" && attrs.class,
  ])
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    enter: "overflow-hidden transition-all linear duration-[400ms]",
    enterFrom: "mt-0 max-h-0 invisible opacity-0",
    enterTo: "mt-3 max-h-[2000px] visible opacity-100",
    entered: "mt-3",
    leave: "overflow-hidden transition-all linear duration-500",
    leaveFrom: "mt-3 max-h-[2000px] visible opacity-100",
    leaveTo: "mt-0 max-h-0 invisible opacity-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(HeadlessDisclosurePanel), { as: "template" }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(as), _mergeProps({ class: _unref(computedClass) }, _unref(_).omit(_unref(attrs), 'class')), {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 16, ["class"]))
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})